import { animate, createTimeline } from 'animejs';

export function toggleMenu() {
  const hamburger = document.querySelector('#mobhead #hamburger');
  const mainMenu = document.querySelector('#mobhead #main-menu');
  if (window.matchMedia("(max-width: 768px)").matches) {
    const tlOpen = createTimeline({
      defaults: {
        ease: 'easeInOutSine',
      },
      autoplay: false,
    })
      .add(mainMenu, {
        height: ['0vh', '100vh'],
        duration: 1, // Instant height expansion
      }, 10)
      .add(mainMenu, {
        opacity: [0, 1],
        duration: 300, // Fade in,
      }, 100);

    const tlClose = createTimeline({
      defaults: {
        ease: 'easeInOutSine',
      },
      autoplay: false,
    })
      .add(mainMenu, {
        opacity: [1, 0],
        duration: 300, // Fade out,
      })
      .add(mainMenu, {
        height: ['100vh', '0vh'],
        duration: 1, // Instant height reduction
        onComplete: () => {
          mainMenu.classList.remove('active');
        }
      }, 300);

    if (hamburger != null) {

      hamburger.addEventListener('click', () => {
        document.body.classList.toggle('open');
        hamburger.classList.toggle('open');

        if (!mainMenu.classList.contains('active')) {
          mainMenu.classList.add('active');
          tlClose.pause(); // Pause closing animation if it was playing
          tlOpen.restart(); // Restart and play the opening animation
        } else {
          tlOpen.pause(); // Pause opening animation if it was playing
          tlClose.restart(); // Restart and play the closing animation
        }
      });
    }
  } else {
    mainMenu.style.height = 'auto';
  }
}

export function toggleSearch() {
  const searchForm = document.querySelector('#searchForm');
  const searchToggle = document.querySelector('#searchToggle');

  const tlOpen = createTimeline({
    defaults: {
      ease: 'easeInOutSine',
    },
    autoplay: false,
  })
    .add(searchForm, {
      height: ['0vh', '100vh'],
      duration: 1, // Instant height expansion
    }, 10)
    .add(searchForm, {
      opacity: [0, 1],
      duration: 300, // Fade in,
    }, 100);

  const tlClose = createTimeline({
    defaults: {
      ease: 'easeInOutSine',
    },
    autoplay: false,
  })
    .add(searchForm, {
      opacity: [1, 0],
      duration: 300, // Fade out,
    })
    .add(searchForm, {
      height: ['100vh', '0vh'],
      duration: 1, // Instant height reduction
      onComplete: () => {
        searchForm.classList.remove('active');
      }
    }, 300);

  searchToggle?.addEventListener('click', () => {
    document.body.classList.add('open');
    searchForm.classList.add('active');
    tlClose.pause(); // Pause closing animation if it was playing
    tlOpen.restart(); // Restart and play the opening animation
  });

  searchForm.addEventListener('click', (e) => {
    if (e.target === searchForm && searchForm.classList.contains('active')) {
      tlOpen.pause(); // Pause opening animation if it was playing
      tlClose.restart(); // Restart and play the closing animation
    }
  });

  // Prevent inner clicks from bubbling to backdrop
  const innerForm = searchForm.querySelector('form');
  if (innerForm) innerForm.addEventListener('click', (e) => e.stopPropagation());

  // Esc to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchForm.classList.contains('active')) {
      tlOpen.pause(); // Pause opening animation if it was playing
      tlClose.restart(); // Restart and play the closing animation
    }
  });
}

let scrollHeader = null;
let mainHeader = null;
let ticking = false;

export const handleScrollHeader = () => {
  scrollHeader = document.getElementById('scrollHeader');
  mainHeader = document.getElementById('masthead');

  if (!scrollHeader || !mainHeader) return;

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateScrollHeader);
      ticking = true;
    }
  };

  const updateScrollHeader = () => {
    const currentScrollY = window.scrollY;
    const mainHeaderHeight = mainHeader.offsetHeight;

    const scrollHeaderActive = currentScrollY > 0;
    const isScrolled = currentScrollY > 0;

    // === COLOR BLANCO AL SCROLL ===
    document.body.classList.toggle('is-scrolled', isScrolled);

    if (scrollHeaderActive) {
      scrollHeader.classList.remove('hidden', '-translate-y-full');
      scrollHeader.classList.add('block', 'translate-y-0');
      document.body.classList.add('has-scroll-header');
    } else {
      scrollHeader.classList.remove('translate-y-0');
      scrollHeader.classList.add('-translate-y-full');
      document.body.classList.remove('has-scroll-header');

      setTimeout(() => {
        if (!document.body.classList.contains('has-scroll-header')) {
          scrollHeader.classList.add('hidden');
          scrollHeader.classList.remove('block');
        }
      }, 300);
    }

    ticking = false;
  };

  window.addEventListener('scroll', handleScroll, { passive: true });


  // Also handle window resize in case header height changes
  window.addEventListener('resize', () => {
    if (!ticking) {
      requestAnimationFrame(updateScrollHeader);
      ticking = true;
    }
  }, { passive: true });
};

window.addEventListener('scroll', () => {
  const masthead = document.getElementById('masthead');
  if (!masthead) return;

  const scrolled = window.scrollY > 0; // o > 10 si querés umbral
  masthead.classList.toggle('is-scrolled', scrolled);
}, { passive: true });